import { render, staticRenderFns } from "./AltasDeServicioPantalla.vue?vue&type=template&id=57187aed&"
import script from "./AltasDeServicioPantalla.vue?vue&type=script&lang=ts&"
export * from "./AltasDeServicioPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('57187aed', component.options)
    } else {
      api.reload('57187aed', component.options)
    }
    module.hot.accept("./AltasDeServicioPantalla.vue?vue&type=template&id=57187aed&", function () {
      api.rerender('57187aed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/AltasServicio/AltasDeServicioPantalla.vue"
export default component.exports